import { render, staticRenderFns } from "./DMList.vue?vue&type=template&id=00f78de0&scoped=true&"
import script from "./DMList.vue?vue&type=script&lang=js&"
export * from "./DMList.vue?vue&type=script&lang=js&"
import style0 from "./DMList.vue?vue&type=style&index=0&id=00f78de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f78de0",
  null
  
)

export default component.exports